import { useState } from "react";
import { sendMessage } from "../../../../../Services/Inbox.js";
import "./CreateMessage.css"
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Enviado from "../../../../../assets/Buzon/enviado.svg";
import DialogModal from "../../../../Modals/dialogModal.jsx";


const CreateMessage = (props) => {

    
    const [formData, setFormData] = useState({for: props.id_for});
    const [success, setSuccess] = useState(false);
    const [showModal, setShowModal] = useState(false)
    const [modalMsg, setModalMsg] = useState("");
    
    const handleSubbmit = async () => {

        if (!formData.subject || !formData.body) {
            setShowModal(true);
            setModalMsg("Complete asunto y cuerpo del mensaje.");
            return;
        }

        let rsp = await sendMessage(formData);

        if(rsp?.Error === false){
            setSuccess(true);

            setTimeout(() => {
                props.setSelectedType(null);
            }, 1000);

        }else{
            setShowModal(true)
            setModalMsg("El mensaje no fue enviado.")
        }
    }

    return(
        <div className="buzon-create-messege-div">
            <DialogModal  showModal={showModal} setShowModal={setShowModal}>
                <h3>{modalMsg}</h3>
            </DialogModal>
            {
                success ?
                <img src={Enviado} className="buzon-create-messege-send"/>
                :
                <>
                <div className="buzon-create-messege-head">
                    <div>
                        <h3>De</h3>
                        <h4>{props.usrData.name}</h4>
                    </div>
                    <div>
                        <h3>Para</h3>
                        <h4>{props.user.name}</h4>
                    </div>
                </div>
                <div className="buzon-create-messege-input-div">
                    <label htmlFor="">Asunto: </label>
                    <input type="text" className="buzon-create-messege-input-text" onChange={e => setFormData({...formData, subject:e.target.value})}/>
                </div>
                <div className="buzon-create-messege-input-body">
                    {
                        //<textarea className="buzon-create-messege-input-textarea" name="" id=""  rows="12" onChange={e => setFormData({...formData, body:e.target.value})}></textarea>
                    }
                    <ReactQuill
                        theme="snow"
                        defaultValue={props.selectedType?.preMessage}
                        onChange={(content) => setFormData({ ...formData, body: content })}
                    />
                </div>
                <div className="buzon-create-messege-controls-div">
                    <button className="green-btn" onClick={handleSubbmit}>Enviar</button>
                </div>
            </>
            }
        </div>
    );
}

export default CreateMessage;
